// Enum de papéis de usuários
export enum Roles {
    admin = "admin",
    secretaria = "secretaria",
    professor = "professor",
    aluno = "aluno",
    funcionario = "funcionario"
   
  }